// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScanEffortLevelSchema } from '../inputTypeSchemas/ScanEffortLevelSchema'

/////////////////////////////////////////
// FULL RESCAN RUN SCHEMA
/////////////////////////////////////////

export const FullRescanRunSchema = z.object({
  effortLevel: ScanEffortLevelSchema,
  id: z.string(),
  tenantId: z.string(),
  applicationId: z.string(),
  requestedByUserId: z.string().nullable(),
  limitBypassExpiresAt: z.coerce.date(),
  startedAt: z.coerce.date(),
  executionStartedAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date(),
})

export type FullRescanRun = z.infer<typeof FullRescanRunSchema>

export default FullRescanRunSchema;
